export const mf = "@newsenec/login";
export const mfShorty = "LG";
